import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import * as Constants from '../Global/constants';
import { getLocalStorageVariables, isEmptyVariable, handleTokenExpiry } from '../Global/commonFunctions';
import ReactSelectDropdown from '../DropdownMenus/ReactSelectDropdownWithSearch';
import AlertDialog from '.';

let userDetails = {};

class AlertRemoveReportResource extends Component {
    constructor(props) {
        super(props);
        this.state = {
            replaceUserId: "",
            replacePlaceholder: "Select User",
            errorMsg: "",
            showLoader: false,
            showAlertDialogInfo: false,
            alertDialogMessageInfo: "",
        };
        userDetails = getLocalStorageVariables();
    }

    componentDidUpdate(prevProps) {
        if (JSON.stringify(prevProps) !== JSON.stringify(this.props) && this.props.showAlertDialog) {
            this.setState({
                replaceUserId: "",
                replacePlaceholder: "Select User",
                errorMsg: "",
                showLoader: false,
            });
        }
    }

    handleAlertDialogCloseInfo = () => {
        this.setState({ showAlertDialogInfo: false, alertDialogMessageInfo: "" });
    }

    replaceUserDropdownClick = (item) => {
        this.setState({
            replaceUserId: item.userId,
            replacePlaceholder: item.fullName,
            errorMsg: "",
        });
    }

    handleProceedButtonClick = () => {
        if (isEmptyVariable(this.state.replaceUserId)) {
            this.setState({ errorMsg: "Please select a replacement user" });
            return;
        }
        this.setState({ showLoader: true });
        userDetails = getLocalStorageVariables();
        fetch(Constants.RemoveReportResource, {
            method: "POST",
            mode: "cors",
            body: new URLSearchParams({
                email: userDetails.email,
                accessToken: userDetails.accessToken,
                assignmentId: this.props.assignmentId,
                removeUserId: this.props.removeUserId,
                replaceUserId: this.state.replaceUserId,
            }),
        })
        .then(res => res.json())
        .then(res => {
            if (handleTokenExpiry(res.responseCode)) return;
            if (res.responseCode === Constants.CODE_SUCCESS) {
                this.setState({ showLoader: false });
                this.props.handleAlertDialogClose(true);
            } else {
                this.setState({
                    showLoader: false,
                    showAlertDialogInfo: true,
                    alertDialogMessageInfo: res.responseMessage,
                });
            }
        });
    }

    render() {
        return (
            <>
            <Modal show={this.props.showAlertDialog} backdrop="static">
                <Modal.Body>
                    <div class="dialog-layout">
                        <button onClick={this.props.handleAlertDialogClose}>
                            <span className="material-icons">close</span>
                        </button>
                        <span className="material-icons">warning</span>
                        <h5>Remove Resource</h5>
                        <p style={{ marginBottom: 10 }}>
                            {"Are you sure you want to remove resource " + this.props.removeUserName}
                        </p>
                        <div className="newuser-dd-layout">
                            <ReactSelectDropdown
                                handleReactSelectClose={this.replaceUserDropdownClick}
                                selectDropdownArr={this.props.usersList}
                                label={"fullName"}
                                value={"userId"}
                                placeholder={this.state.replacePlaceholder}
                            />
                        </div>
                        {
                            this.state.errorMsg &&
                            <span className="cm-error dialog-error">{this.state.errorMsg}</span>
                        }
                        <div class="dialog-btn-layout">
                            <a class="alert-cancel" href="javascript:void(0);"
                                onClick={this.props.handleAlertDialogClose}>
                                Cancel
                            </a>
                            <a class="alert-proceed alert-dialog-warning" href="javascript:void(0);"
                                onClick={this.handleProceedButtonClick}
                                style={{ marginLeft: "10px" }}>
                                {this.state.showLoader
                                    ? <div class="loader-btn mt-2"></div>
                                    : "Remove"}
                            </a>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <AlertDialog
                showAlertDialog={this.state.showAlertDialogInfo}
                handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                type={Constants.ALERT_TYPE_ALERT}
                alertDialogMessage={this.state.alertDialogMessageInfo}
                proceedBtnClick={this.handleAlertDialogCloseInfo}
                proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL}
            />
            </>
        );
    }
}

export default AlertRemoveReportResource;
